var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Orion_info-help (1)",
    transform: "translate(-1 -.623)",
    strokeWidth: 2,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 1.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77 8.249h1.042v5.728m-1.042.002h2.083"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(9 5.623)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0iT3Jpb25faW5mby1oZWxwXzFfIiBkYXRhLW5hbWU9Ik9yaW9uX2luZm8taGVscCAoMSkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIC0wLjYyMykiPgogICAgPGNpcmNsZSBpZD0ibGF5ZXIyIiBjeD0iOCIgY3k9IjgiIHI9IjgiIHN0cm9rZS13aWR0aD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxLjYyMykiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGlkPSJsYXllcjEiIGQ9Ik0yOCwyNmgxLjA0MnY1LjcyOE0yOCwzMS43M2gyLjA4MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5LjIzIC0xNy43NTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxjaXJjbGUgaWQ9ImxheWVyMS0yIiBkYXRhLW5hbWU9ImxheWVyMSIgY3g9IjAuNSIgY3k9IjAuNSIgcj0iMC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5IDUuNjIzKSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgInfo as ReactComponent };